import { Image, ImageProps } from 'theme-ui'

const Curve = (props: ImageProps) => {
  return <Image width={16} src="/imgs/curve.png" {...props} />
}

export default Curve
